import * as yup from 'yup'

import { ELocationType } from '~/features/agents/models'
import {
  LOCATION_CITY_MAX_LENGTH,
  LOCATION_STATE_MAX_LENGTH,
  LOCATION_STREET_ADDRESS_1_MAX_LENGTH,
  LOCATION_STREET_ADDRESS_2_MAX_LENGTH,
  LOCATION_ZIP_CODE_MAX_LENGTH,
} from '~/features/locations/constants'
import { ELocationFormKeys, TLocationForm } from '~/features/locations/models'

export const locationValidationSchema = yup.object<TLocationForm>({
  [ELocationFormKeys.name]: yup
    .string()
    .trim()
    .required('Location name is required'),
  [ELocationFormKeys.streetAddress1]: yup
    .string()
    .nullable()
    .trim()
    .max(LOCATION_STREET_ADDRESS_1_MAX_LENGTH),
  [ELocationFormKeys.streetAddress2]: yup
    .string()
    .nullable()
    .trim()
    .max(LOCATION_STREET_ADDRESS_2_MAX_LENGTH),
  [ELocationFormKeys.city]: yup
    .string()
    .nullable()
    .trim()
    .max(LOCATION_CITY_MAX_LENGTH),
  [ELocationFormKeys.state]: yup
    .string()
    .nullable()
    .trim()
    .max(LOCATION_STATE_MAX_LENGTH),
  [ELocationFormKeys.zipCode]: yup
    .string()
    .nullable()
    .trim()
    .max(LOCATION_ZIP_CODE_MAX_LENGTH),
  [ELocationFormKeys.timezone]: yup.string().nullable().trim(),
  [ELocationFormKeys.hoursText]: yup.string().nullable().trim(),
  [ELocationFormKeys.type]: yup
    .string()
    .oneOf([...Object.values(ELocationType), ''])
    .required('Location type is required'),
})

export const normalizeEmptyStringsToNull = (values: object) =>
  Object.fromEntries(
    Object.entries(values).map(([key, value]) => [
      key,
      value === '' ? null : value,
    ]),
  )

export const getDefaultLocationFormValues = (): TLocationForm => ({
  [ELocationFormKeys.name]: '',
  [ELocationFormKeys.streetAddress1]: '',
  [ELocationFormKeys.streetAddress2]: '',
  [ELocationFormKeys.city]: '',
  [ELocationFormKeys.state]: '',
  [ELocationFormKeys.zipCode]: '',
  [ELocationFormKeys.timezone]: '',
  [ELocationFormKeys.hoursText]: '',
  [ELocationFormKeys.type]: ELocationType.single,
})
